import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { loginReducer } from "./auth/loginReducer";
import { heReducer } from './category/heReducer';
import { khoiReducer } from './category/khoiReducer';
import { lopReducer } from './category/lopReducer';
import { monHocReducer } from './category/monHocReducer';
import { truongReducer } from './category/truongReducer';
import { appConfigReducer } from './common/appConfigReducer';
import { subSystemReducer } from "./sub-sytem/subSystemReducer";
import { roleReducer } from './user/roleReducer';
import { userReducer } from "./user/userReducer";
import { venderReducer } from './user/venderReducer';

const reducers = combineReducers({
    auth: authReducer,
    login: loginReducer,
    user: userReducer,
    subSytem: subSystemReducer,
    truong: truongReducer,
    khoi: khoiReducer,
    monHoc: monHocReducer,
    lop:lopReducer,
    he: heReducer,
    role: roleReducer,
    appConfig: appConfigReducer,
    vender: venderReducer
})

export default reducers

export type RootState = ReturnType<typeof reducers>